import { TNotificationSetting } from "../../../types";
import { baseApi } from "./baseApi";

export const notificationSettingsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getNotificationSettings: builder.query<TNotificationSetting[], void>({
            query: () => ({ url: "/notification-settings" }),
            transformResponse: (response: { settings: TNotificationSetting[] }) => response.settings ?? [],
            providesTags: ["NotificationSettings"],
        }),
        updateNotificationSetting: builder.mutation<
            { settings: TNotificationSetting[] },
            { type: string; is_enabled: boolean }
        >({
            query: ({ type, is_enabled }) => ({
                url: `/notification-settings/${type}`,
                method: "PATCH",
                body: { is_enabled },
            }),
            invalidatesTags: ["NotificationSettings"],
        }),
    }),
});

export const {
    useGetNotificationSettingsQuery,
    useUpdateNotificationSettingMutation,
} = notificationSettingsApi;